import { NotificationType } from 'types/notifications'

import { generateDeckUrl } from 'utils/deckSeo'

const NOTIFICATION_TYPE = {
  FORUM_THREAD: 'ForumThread',
  DECK_THREAD: 'DeckThread',
  GLOBAL: 'Global',
  STICKY: 'Sticky',
  NEWS: 'News',
  DECK: 'Deck',
  USER: 'Profile',
  FEATURE: 'Features',
  DECK_SHARED: 'DeckUserEditorLink',
  CONTEST: 'Contest',
  AD_FREE_TRIAL_EXPIRED: 'AdFreeTrialExpired',
  ACTIVITY_THRESHOLD: 'ActivityThreshold',
}

/**
 * Takes a notification object from the api and generates a title string for a notification along with its link path.
 */
const buildNotificationRoute = (n: NotificationType): string => {
  if (n.notificationType === NOTIFICATION_TYPE.FORUM_THREAD) return `/forum/thread/${n.selfId ?? n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.GLOBAL) return `/forum/thread/${n.selfId ?? n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.STICKY) return `/forum/thread/${n.selfId ?? n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.FEATURE) return `/forum/thread/${n.selfId ?? n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.DECK_THREAD) return generateDeckUrl(n.linkId)
  else if (n.notificationType === NOTIFICATION_TYPE.DECK) return generateDeckUrl(n.linkId)
  else if (n.notificationType === NOTIFICATION_TYPE.NEWS) return `/news/${n.selfId ?? n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.USER) return `/user/${n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.DECK_SHARED) return generateDeckUrl(n.linkId)
  else if (n.notificationType === NOTIFICATION_TYPE.CONTEST) return `/contest/discussion/${n.linkId}`
  else if (n.notificationType === NOTIFICATION_TYPE.AD_FREE_TRIAL_EXPIRED) return `/accountSettings/account-details`
  else if (n.notificationType === NOTIFICATION_TYPE.ACTIVITY_THRESHOLD) return `/activity`

  return '/404' // Shouldn't happen
}

export default buildNotificationRoute

export function notificationTextOverride(n: NotificationType): string {
  if (n.notificationType === NOTIFICATION_TYPE.AD_FREE_TRIAL_EXPIRED)
    return 'Your ad-free trial expired. Please consider supporting us on patreon!'

  if (n.notificationType === NOTIFICATION_TYPE.ACTIVITY_THRESHOLD) return 'View your deckbuilding activity.'

  return n.text
}
